module.exports = __webpack_public_path__ + "static/lessons-sweet-potato-2b9dcfc170a1091507ec90cd4cb72900.jpg";